import { useRef } from "react";

export const TaskDetail = ({ label, containerCss, children }) => {
  const elementRef = useRef(null);

  return (
    <div ref={elementRef} className={`task-detail p-2 ${containerCss}`}>
      <div className="mx-3">
        <div className="fw-600 fs-14 et-black my-2">{label}</div>
        <div className="task-detail-value">{children}</div>
      </div>
    </div>
  );
};
